// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__20p3f","content":"LayoutSettings_content__iToVW"};